<template>
  <component :is="currentView" />
</template>

<script>
import { mapGetters } from 'vuex';
import { isEmpty } from '@/utils/basic';
import WInstanceDomain from './domain';
import WInstanceTier from './tier';
import WInstanceNode from './node';

export default {
  name: 'WInstance',
  components: {
    WInstanceDomain,
    WInstanceTier,
    WInstanceNode,
  },
  data() {
    return {
      currentView: null,
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    selectedNode: {
      immediate: true,
      handler(newNode, oldNode) {
        if (isEmpty(this.currentView) || newNode.treeKey !== oldNode.treeKey) {
          this.changeView();
        }
      },
    },
  },
  methods: {
    changeView() {
      const treeType = this.selectedNode.type;
      if (treeType === 'domain') {
        this.currentView = WInstanceDomain.name;
      } else if (treeType === 'group') {
        this.currentView = WInstanceTier.name;
      } else if (treeType === 'obj') {
        this.currentView = WInstanceNode.name;
      } else {
        this.currentView = null;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/apm/instance/index.vue